<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <div class="form-row">
    <label class="col-sm-4 col-form-label"
           for="nameOrgantraeger{{index}}">{{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE.ORGANGESELLSCHAFT.NICHT_NATUERLICHE_PERSON.NAME_ORGANTRAEGER' | translate }}</label>
    <div class="col-sm-8">
      <input class="form-control" datevMessagePath="nameOrgantraeger{{objectId}}" formControlName="nameOrgantraeger" id="nameOrgantraeger{{index}}"
             type="text"
             utilsCheckValidity utilsControlState utilsMarkRequired
             utilsValidationMessage/>
    </div>
  </div>

</form>
